import { format } from 'date-fns';
import { convertUTCToTimezone } from '@betgames/bg-tools';
import { DEFAULT_DATE_FORMAT } from '@bg-shared/constants/dateFormats';

export const isSameDay = (value1: string, value2: string, timezone = 0): boolean => {
    const date1 = format(
        convertUTCToTimezone(new Date(value1).getTime(), timezone),
        DEFAULT_DATE_FORMAT,
    );
    const date2 = format(
        convertUTCToTimezone(new Date(value2).getTime(), timezone),
        DEFAULT_DATE_FORMAT,
    );

    return date1 === date2;
};
